import styled from '@emotion/styled'
import { metrics } from '../../__styling'

export const StyledAside = styled('aside')(({ theme }) => ({
    marginBottom:
        theme.kind === 'thenightly'
            ? metrics.thenightly.textMargin
            : theme.margins.lg,
}))
